import { Chat, MessageSquare2Outline } from '@lyearn/icons';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import type { ContentConfigProps } from '@/modules/content/types';
import routes from '@/pages/corporate/routes';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

const config: ContentConfigProps = {
  routes: {
    create: routes.RoleplayCreator,
    edit: routes.RoleplayEditor,
    details: routes.RoleplayDetails,
    manageDetails: routes.AdminRoleplayDetails,
  },
  label: RESOURCE_TYPE_LABEL_CONFIG[ResourceTypeEnum.Roleplay],
  icons: {
    Type: MessageSquare2Outline,
    Create: Chat,
    Icon: Chat,
    getContentImage: (content: ContentEntity) => ({ image: content.cover?.url! }),
  },
};

export default config;
